import { render, staticRenderFns } from "./PainterIncome.vue?vue&type=template&id=ede9d916&scoped=true"
import script from "./PainterIncome.vue?vue&type=script&lang=js"
export * from "./PainterIncome.vue?vue&type=script&lang=js"
import style0 from "./PainterIncome.vue?vue&type=style&index=0&id=ede9d916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede9d916",
  null
  
)

export default component.exports